import { computed, effect, EffectRef, Signal, untracked } from '@angular/core'

export function explicitEffect<T>(value: Signal<T>, callback: (this: void, value: T) => void): EffectRef {
  return effect(() => untracked(callback.bind(void 0, value())))
}
// export function explicitComputed<T, R>(value: Signal<T>, callback: (this: void, value: T) => R): Signal<R> {
//   return computed(() => untracked(callback.bind(void 0, value())))
// }

export function explicitComputed<T, R>(value: Signal<T>, callback: (this: void, value: T) => R): Signal<R>
export function explicitComputed<T extends any[], R>(
  values: { [K in keyof T]: Signal<T[K]> },
  callback: (this: void, ...values: T) => R,
): Signal<R>
export function explicitComputed<T, R>(
  valueOrValues: Signal<T> | Array<Signal<any>>,
  callback: (this: void, ...values: any[]) => R,
): Signal<R> {
  if (Array.isArray(valueOrValues)) {
    return computed(() => untracked(callback.bind(void 0, ...valueOrValues.map((v) => v()))))
  }
  return computed(() => untracked(callback.bind(void 0, valueOrValues())))
}
